import React from "react";
import { ITranslationContextProps } from "contexts/TranslationContext";
import {
  Breadcrumbs,
  IBreadcrumbsContent,
} from "components/common/Breadcrumbs";
import { IBreadcrumbsContentKeys } from "components/common/Breadcrumbs/Breadcrumbs";

declare type WithBreadcrumbsProps = ITranslationContextProps;

export default function withBreadcrumbs<P extends WithBreadcrumbsProps>(
  WrappedComponent:
    | React.ComponentClass<P>
    | React.FC<React.PropsWithChildren<P>>
): typeof React.Component {
  return class extends React.Component<P> {
    public render() {
      const breadcrumbsContent: IBreadcrumbsContent =
        this.getBreadcrumbsTranslation();

      return (
        <React.Fragment>
          <Breadcrumbs content={breadcrumbsContent} />
          <WrappedComponent {...this.props} />
        </React.Fragment>
      );
    }

    private getBreadcrumbsTranslation = () =>
      this.props.translator
        .getTranslator("breadcrumbs", true)
        .createTranslationObject<IBreadcrumbsContent>(IBreadcrumbsContentKeys);
  };
}
